module.exports = __webpack_public_path__ + "static/media/index.2d0a2ffd.less";